import {useLocation, useNavigate} from 'react-router-dom'
import {EnvelopeCheck} from 'react-bootstrap-icons'
import {useTranslation} from 'react-i18next'
import UnauthenticatedLayout from '../../components/layout/UnauthenticatedLayout'
import {ImpactButton} from '../../components/ui'

interface LocationState {
    email?: string
}

const VerifyEmailPendingPage: React.FC = () => {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const state = location.state as LocationState
    const email = state?.email

    return (
        <UnauthenticatedLayout>
            <div className="text-center">
                <div className="mb-4">
                    <EnvelopeCheck size={64}/>
                </div>

                <h2 className="mb-3">{t('auth:verify_email_title', 'Check Your Email')}</h2>

                {email && (
                    <p className="mb-3">
                        {t('auth:verify_email_message',
                            'We sent a verification link to'
                        )}:
                        <br/>
                        <strong>{email}</strong>
                    </p>
                )}

                <div className="alert alert-info mb-0">
                    <small>
                        {t('auth:verification_link_expires',
                            'The verification link will expire in 24 hours. If you don\'t see the email, please check your spam folder.'
                        )}
                    </small>
                </div>

                <ImpactButton
                    onClick={() => navigate('/login')}
                    fullWidth
                    className="mt-3"
                >
                    {t('auth:go_to_login', 'Go to Login')}
                </ImpactButton>
            </div>
        </UnauthenticatedLayout>
    )
}

export default VerifyEmailPendingPage
